export var typePositionCreateOrder={close:"close",//thanh lý vị thế
rolled:"rolled",//đảo chiều vị thế
open:"open"//(hoặc không truyền) - đặt lệnh bình thường
};